import { Col, Container, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { REGEX } from "../../utils/utils";
import { useProductForm } from "../productModalForm";

const defaultValues = {
  receiptUnitMeasure: "",
  dispatchUnitMeasure: ""
};

export const UnitsConfigurationForm = () => {
  const { disabled } = useProductForm();

  const {
    register,
    formState: { errors },
  } = useFormContext({
    defaultValues: defaultValues,
  });

  return (
    <Container>
      <h4>Unidades de medida</h4>
      <hr />
      <Row>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="receiptUnitMeasure" className="form-label">
            Unidad de medida para recibo
          </label>
          <input
            {...register("receiptUnitMeasure", {
              maxLength: {
                value: 100,
                message: "Máximo 100 caracteres",
              },
            })}
            id="receiptUnitMeasure"
            type="text"
            placeholder="Ej: Caja, Pallet, Unidad"
            className={`form-control ${!!errors?.receiptUnitMeasure && "is-invalid"}`}
            disabled={disabled}
          />
          {!!errors?.receiptUnitMeasure && (
            <span className="error-message">
              {errors?.receiptUnitMeasure?.message ||
                "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
        <Form.Group as={Col} className="px-3 pb-2">
          <label htmlFor="dispatchUnitMeasure" className="form-label">
            Unidad de medida para despacho
          </label>
          <input
            {...register("dispatchUnitMeasure", {
              maxLength: {
                value: 100,
                message: "Máximo 100 caracteres",
              },
              pattern: {
                value: REGEX.ALPHANUMERIC_WITH_SPACES,
                message: "Solo se permiten letras y números",
              },
            })}
            id="dispatchUnitMeasure"
            type="text"
            placeholder="Ej: Caja, Pallet, Unidad"
            className={`form-control ${!!errors?.dispatchUnitMeasure && "is-invalid"}`}
            disabled={disabled}
          />
          {!!errors?.dispatchUnitMeasure && (
            <span className="error-message">
              {errors?.dispatchUnitMeasure?.message ||
                "Este campo es obligatorio"}
            </span>
          )}
        </Form.Group>
      </Row>
    </Container>
  );
};
